export const SET_ERROR = 'newVisit/SET_ERROR'
export const SET_IS_VISIT_RESCHEDULED_SUCCESS = 'newVisit/SET_IS_VISIT_RESCHEDULED_SUCCESS'

export const SEARCH_FOR_PATIENT = 'newVisit/SEARCH_FOR_PATIENT'
export const SEARCH_FOR_PATIENT_SUCCESS = 'newVisit/SEARCH_FOR_PATIENT_SUCCESS'
export const SEARCH_FOR_PATIENT_ERROR = 'newVisit/SEARCH_FOR_PATIENT_ERROR'

export const GET_PROVIDER_INFO = 'newVisit/GET_PROVIDER_INFO'
export const GET_PROVIDER_INFO_SUCCESS = 'newVisit/GET_PROVIDER_INFO_SUCCESS'
export const GET_PROVIDER_INFO_ERROR = 'newVisit/GET_PROVIDER_INFO_ERROR'

export const GET_CREDIT_CARDS = 'newVisit/GET_CREDIT_CARDS'
export const GET_CREDIT_CARDS_SUCCESS = 'newVisit/GET_CREDIT_CARDS_SUCCESS'
export const GET_CREDIT_CARDS_ERROR = 'newVisit/GET_CREDIT_CARDS_ERROR'

export const ADD_CREDIT_CARD = 'newVisit/ADD_CREDIT_CARD'
export const ADD_CREDIT_CARD_SUCCESS = 'newVisit/ADD_CREDIT_CARD_SUCCESS'
export const ADD_CREDIT_CARD_ERROR = 'newVisit/ADD_CREDIT_CARD_ERROR'

export const GET_PAYMENT_KEYS = 'newVisit/GET_PAYMENT_KEYS'
export const GET_PAYMENT_KEYS_SUCCESS = 'newVisit/GET_PAYMENT_KEYS_SUCCESS'
export const GET_PAYMENT_KEYS_ERROR = 'newVisit/GET_PAYMENT_KEYS_ERROR'

export const BOOK_VISIT = 'newVisit/BOOK_VISIT'
export const BOOK_VISIT_SUCCESS = 'newVisit/BOOK_VISIT_SUCCESS'
export const BOOK_VISIT_ERROR = 'newVisit/BOOK_VISIT_ERROR'

export const SEARCH_FOR_PROVIDER_AVAILABILITY = 'newVisit/SEARCH_FOR_PROVIDER_AVAILABILITY'
export const SEARCH_FOR_PROVIDER_AVAILABILITY_SUCCESS = 'newVisit/SEARCH_FOR_PROVIDER_AVAILABILITY_SUCCESS'
export const SEARCH_FOR_PROVIDER_AVAILABILITY_ERROR = 'newVisit/SEARCH_FOR_PROVIDER_AVAILABILITY_ERROR'

export const RESCHEDULE_VISIT = 'newVisit/RESCHEDULE_VISIT'
export const RESCHEDULE_VISIT_SUCCESS = 'newVisit/RESCHEDULE_VISIT_SUCCESS'
export const RESCHEDULE_VISIT_ERROR = 'newVisit/RESCHEDULE_VISIT_ERROR'

export const DELETE_BOOKING = 'newVisit/DELETE_BOOKING'

export const SET_NEW_VISIT_SELECTED_PATIENT = 'newVisit/SET_NEW_VISIT_SELECTED_PATIENT'
export const CLEAR_NEW_VISIT_SELECTED_PATIENT = 'newVisit/CLEAR_NEW_VISIT_SELECTED_PATIENT'

export const newVisitBlackList = [ADD_CREDIT_CARD, ADD_CREDIT_CARD_ERROR, ADD_CREDIT_CARD_SUCCESS]
